<section class="tours-destination">
    <div class="container">
        <div class="tours-destination-title">
            <h2 class="hclass">{{ pageTitle }}</h2>
        </div>
        <div class="row">
            @for(countries of locationList;track countries){
                <div class="col-lg-4 col-md-6">
                    <div class="destination-box">
                        <div class="destination-group-title">{{countries?.name}}</div>
                        <div class="destination-group-list">
                            <ul class="p-0">
                                @for(location of countries?.child_locations;track location){
                                    <li><a href="javascript:void(0)"
                                        [routerLink]="'/location-region/'+location?.slug" class="set-icon-text">
                                        <div class="svg-flg-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <path d="M10.4912 7.00002C10.4912 7.21957 10.4073 7.43908 10.24 7.60647L4.97274 12.8737C4.63768 13.2088 4.09443 13.2088 3.7595 12.8737C3.42457 12.5388 3.42457 11.9956 3.7595 11.6605L8.42029 7.00002L3.75966 2.33948C3.42473 2.00441 3.42473 1.46132 3.75966 1.12642C4.09459 0.791193 4.63784 0.791193 4.97291 1.12642L10.2402 6.39357C10.4075 6.56104 10.4912 6.78056 10.4912 7.00002Z" fill="#E96840"/>
                                            </svg>
                                        </div>
                                        {{location?.name}}</a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</section>